import { useState } from 'react';

export default function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [errorMsg, setErrorMsg] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypot = (formData.get('phone_alt') as string || '').trim();
    if (honeypot) {
      setStatus('success');
      setEmail('');
      return;
    }

    setStatus('loading');
    setErrorMsg('');

    try {
      const submitData = new FormData();
      submitData.append('email', email);
      const response = await fetch('https://readdy.ai/api/form/d9q6h7snlsngrm4llscg', {
        method: 'POST',
        body: submitData,
      });
      const responseText = await response.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }

      if (response.ok && parsed?.code === 'OK') {
        setStatus('success');
        setEmail('');
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText;
        setStatus('error');
        setErrorMsg(serverMsg || '订阅失败，请稍后再试');
      }
    } catch {
      setStatus('error');
      setErrorMsg('网络错误，请检查网络连接后重试');
    }
  };

  return (
    <section className="py-16 md:py-20 bg-primary-500">
      <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
        <p className="text-background-50/70 text-sm font-medium tracking-wider mb-3">
          禅意资讯
        </p>
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-4">
          订阅草灯文化资讯
        </h2>
        <p className="text-background-50/80 text-sm leading-relaxed mb-8 max-w-md mx-auto">
          定期接收草灯和尚的禅意故事、修行哲学与生活美学内容，
          让东方智慧照亮您的每一天。
        </p>

        {status === 'success' ? (
          <div className="bg-background-50/15 rounded-lg px-6 py-4 text-background-50 text-sm">
            <i className="ri-check-line mr-2"></i>
            感谢您的订阅！我们会定期为您推送精选内容。
          </div>
        ) : (
          <form
            data-readdy-form
            id="newsletter-form"
            onSubmit={handleSubmit}
            className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto"
          >
            <input
              type="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="请输入您的邮箱地址"
              required
              className="flex-1 px-4 py-3 rounded-full bg-background-50 text-foreground-900 placeholder:text-foreground-400 text-sm outline-none focus:ring-2 focus:ring-background-50/50 transition-shadow"
            />
            <input
              type="text"
              name="phone_alt"
              tabIndex={-1}
              autoComplete="off"
              aria-hidden="true"
              readOnly
              className="absolute opacity-0 pointer-events-none"
              style={{ position: 'absolute', left: '-9999px' }}
            />
            <button
              type="submit"
              disabled={status === 'loading'}
              className="px-8 py-3 rounded-full bg-foreground-900 text-background-50 font-medium text-sm hover:bg-foreground-800 transition-colors whitespace-nowrap disabled:opacity-70"
            >
              {status === 'loading' ? '提交中...' : '立即订阅'}
            </button>
          </form>
        )}
        {status === 'error' && errorMsg && (
          <p className="mt-3 text-sm text-background-50/80">{errorMsg}</p>
        )}
      </div>
    </section>
  );
}